import type { FieldId } from '~/features/fields/types/FieldId';

import { PromptModelVersion } from '~/api/sylvanus/typedefs.autogen';
import { FieldModel } from '~/features/x-ray/fields/types';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { mapModelVersionToFieldModel } from './transformers';

export const DEPRECATED_getPromptModelVersion = async ({
  modelId,
  version,
  fieldId, // TODO: remove this dependency (sylvanus doesn't need it and neither should our transform)
  highlightMethod,
  targetEntityUfId,
}: {
  modelId: Uuid;
  version: number;
  fieldId?: FieldId;
  highlightMethod: string;
  targetEntityUfId?: string;
}): Promise<FieldModel> => {
  const response: PromptModelVersion = await sylvanus.get(
    `/model/${modelId}/version/${version}`,
  );

  return mapModelVersionToFieldModel({
    modelId,
    version: response,
    fieldId,
    highlightMethod,
    targetEntityUfId,
    optimizeState:
      response.optimize?.version_number === response.version_number
        ? response.optimize?.state
        : null,
    publishStatus: null,
  });
};
